import { render } from "./ProprtyList.vue?vue&type=template&id=065d5576&scoped=true"
import script from "./ProprtyList.vue?vue&type=script&lang=js"
export * from "./ProprtyList.vue?vue&type=script&lang=js"

import "./ProprtyList.vue?vue&type=style&index=0&id=065d5576&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065d5576"]])

export default __exports__